export const DONUT_SIZE = 95;
export const DONUT_STROKE_WIDTH = 8;
export const DONUT_CENTER = DONUT_SIZE / 2;
export const DONUT_RADIUS = DONUT_CENTER - DONUT_STROKE_WIDTH;
export const DONUT_CIRCUMFERENCE = 2 * Math.PI * DONUT_RADIUS;

export const getFontSize = (length: number): number => {
  if (length <= 5) {
    return 17;
  }
  if (length <= 7) {
    return 15;
  }
  return 13;
};
